import React, {useState} from 'react';
import {Button, Row, Col, Label, Modal, Card} from 'reactstrap';
import {useForm, Controller} from 'react-hook-form';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import axios from 'axios';
import Dropzone from 'react-dropzone';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {SweetAlert} from '../Common/SweetAlert';

const ModalConfirmDispatch = ({dispatch}) => {
  const [modal, setModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [successMsg, setSuccessMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {control, handleSubmit} = useForm({
    defaultValues: {
      date_of_receipt: '',
      storage_location: '',
      package_damaged: '',
    },
  });

  const toggleModal = () => {
    setModal(!modal);
    document.body.classList.add('no_padding');
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  const handleAcceptedFiles = (files) => {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setSelectedFiles(files);
  };

  const confirmDispatch = (data) => {
    const url = process.env.REACT_APP_APIURL + 'dispatch/confirm';
    const authToken = authHeader();

    const formData = new FormData();
    selectedFiles.forEach((file) => formData.append('file[]', file));
    formData.append('data', JSON.stringify(data));

    setIsLoading(true);
    axios
        .post(url, formData, {headers: authToken})
        .then(() => {
          setIsLoading(false);
          setSuccessMsg(true);
        })
        .catch(() => {
          setIsLoading(false);
          setErrorMsg(true);
        });
  };

  const onSubmit = (values) => {
    const confirmedDispatch = {
      claim_id: dispatch.id,
      included: dispatch.print_head_replacements.concat(dispatch.other_part_replacements),
      date_of_receipt: values.date_of_receipt,
      storage_location: values.storage_location,
      package_damaged: values.package_damaged,
      files: selectedFiles,
    };
    confirmDispatch(confirmedDispatch);
  };

  return (
    <>
      <Button color="yellow" className="text-dark font-weight-bold" onClick={toggleModal}>
        Confirm
      </Button>

      <Modal size="lg" isOpen={modal} toggle={toggleModal} centered>
        <div className="modal-body">
          <button type="button" className="close" onClick={() => setModal(false)} aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <Row>
            <Col md={1}>
              <div className="avatar-sm">
                <span className="avatar-title rounded-circle bg-primary text-white">
                  <i className="bx bx-check-circle bx-sm" />
                </span>
              </div>
            </Col>
            <Col md={11}>
              <h5>Reception of parts</h5>
              <p>Please confirm the following reception</p>

              <h5>{dispatch.fault_report_no}</h5>

              <Row>
                <Col md={6}>
                  <h6>Included in package</h6>
                  <Label className="font-size-18">
                    {dispatch.print_head_replacements?.map((p, idx) => (
                      <div key={'ph_' + idx}>{p.original_serial_no}</div>
                    ))}
                    {dispatch.other_part_replacements?.map((p, idx) => (
                      <div key={'op_' + idx}>{p.number}</div>
                    ))}
                  </Label>
                </Col>
                <Col md={6}>
                  <h6>Sender/Dealer</h6>
                  <strong>{dispatch.dealer.name}</strong>
                  <p>
                    {dispatch.dealer.street} {dispatch.dealer.street_no}
                    <br />
                    {dispatch.dealer.zip_code} {dispatch.dealer.city}
                    <br />
                    {dispatch.dealer.country}
                  </p>
                </Col>
              </Row>

              <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                  name="date_of_receipt"
                  control={control}
                  rules={{required: true}}
                  render={({field}) => (
                    <input
                      {...field}
                      type="date"
                      max={moment().format('YYYY-MM-DD')}
                      className="form-control mb-2"
                      placeholder="Date of receipt *"
                    />
                  )}
                />

                <Controller
                  name="storage_location"
                  control={control}
                  rules={{required: true}}
                  render={({field}) => (
                    <input {...field} type="text" className="form-control mb-2" placeholder="Storage place *" />
                  )}
                />

                <Controller
                  name="package_damaged"
                  control={control}
                  render={({field}) => <textarea {...field} className="form-control mb-2" placeholder="Package damaged?" />}
                />

                <strong>Photo of Problem</strong>
                <Dropzone
                  onDrop={handleAcceptedFiles}
                  accept=".jpg,.pdf"
                  multiple={false}
                >
                  {({getRootProps, getInputProps}) => (
                    <div className="dropzone">
                      <div className="dz-message needsclick" {...getRootProps()}>
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>

                <div className="dropzone-previews mt-3">
                  {selectedFiles.map((f, i) => (
                    <Card className="mt-1 mb-0 shadow-none border" key={i}>
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt={f.name}
                              src={f.preview}
                            />
                          </Col>
                          <Col>
                            <Link to="#" className="text-muted font-weight-bold">{f.name}</Link>
                            <p className="mb-0"><strong>{f.formattedSize}</strong></p>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  ))}
                </div>

                <div className="text-sm-right mt-2">
                  <Button color="yellow" type="submit" disabled={isLoading}>
                    {isLoading && <i className="bx bx-loader bx-spin mr-2" />}
                    Confirm
                  </Button>
                </div>
              </form>

              <p className="mt-2"><strong>Announced part not included?</strong> Please write an email to gtsupport@brother-ism.com</p>
            </Col>
          </Row>
        </div>
      </Modal>

      {successMsg && (
        <SweetAlert
          title="Good job!"
          success
          onConfirm={() => window.location.reload()}
        >
          Dispatch was submitted successfully.
        </SweetAlert>
      )}

      {errorMsg && (
        <SweetAlert
          title="Request could not be submitted!"
          warning
          onConfirm={() => setErrorMsg(false)}
        >
          There was an error while submitting your request. Please try again or contact our team.
        </SweetAlert>
      )}
    </>
  );
};

export default ModalConfirmDispatch;
